export default "__VITE_ASSET__BMy1WtpC__";